export default class winsizes {
  constructor() {
    this.mainWidth = 0;
    this.vh();
    this.resize();
  }

  vh(){
    window.vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${window.vh}px`);

    // window.maxvh = window.innerHeight*0.01;
    // document.documentElement.style.setProperty('--maxvh', `${window.maxvh}px`);
  }

  resize(){
    let newMainWidth = $('main').outerWidth();
    if(newMainWidth!==this.mainWidth || !md.mobile()){
      this.vh();
    }
    this.mainWidth = newMainWidth;

    // if((window.innerHeight*0.01) > window.maxvh){
    //   window.maxvh = window.innerHeight*0.01;
    //   document.documentElement.style.setProperty('--maxvh', `${window.maxvh}px`);
    // }
  }

}
